import { LiftIgniterBatcher } from '../lib/liftIgniter/eventBatcher';

const BATCH_EVENT_NAME = 'ad_viewability';

type EventName = 'adViewability';

class LiftIgniterAdViewabilityListener {
    private reporter = new LiftIgniterBatcher<EventName>(BATCH_EVENT_NAME);

    onVisibilityChanged = (event: Event) => {
        if (!(event instanceof CustomEvent)) {
            return;
        }

        return this.reporter.track('adViewability', event.detail);
    };
}

class LiftIgniterAdViewabilityReporter {
    reporter: LiftIgniterAdViewabilityListener | null = null;

    listenForAdViewabilityEvents() {
        if (this.reporter !== null) {
            throw new Error('Already listening');
        }

        this.reporter = new LiftIgniterAdViewabilityListener();

        document.addEventListener('phoenix:ad:visibility-changed', this.reporter.onVisibilityChanged);
    }
}

export default new LiftIgniterAdViewabilityReporter();
